import axios from "axios";

const bootstrap = async () => {
  const response = await axios.get('account/api/v1/bootstrap');

  return response.data;
};

export default bootstrap;
